import type { CourseStats } from '@yandex-int/k-common';
import * as api from '@yandex-int/k-common/client/api';
// @ts-ignore
import { showNetworkError } from 'platform-components/src/components/notification/actions';
import { call, put, takeLatest, all } from 'redux-saga/effects';

import * as actions from './actions';
import * as constants from './constants';

export function* courseStatsSagasWatcher() {
    yield all([takeLatest(constants.GET_COURSE_STATS_REQUEST, getCourseStatsSaga)]);
}

function* getCourseStatsSaga(action: ReturnType<typeof actions.getCourseStatsRequest>) {
    const { courseId } = action;

    try {
        const stats: CourseStats = yield call(api.getCourseStats, courseId);
        yield put(actions.getCourseStatsSuccess(courseId, stats));
    } catch (error) {
        console.error(error);

        yield put(actions.getCourseStatsError(courseId));
        yield put(showNetworkError(error));
    }
}
